const Signatures = ({date}) => (
  <div style={{ padding: '20px' }}>
    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '10px 0px',
      margin: '0 !important'
    }}>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li style={{fontWeight:"600"}}>{date}</li>
          <li style={{ marginTop: '10px' }}>Admission Date</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>___________________</li>
          <li style={{ marginTop: '10px' }}>पिता/ अभिभावक के हस्ताक्षर
</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_______________</li>
          <li style={{ marginTop: '10px' }}>प्रवेशार्थी के हस्ताक्षर</li>
        </ul>
      </li>
    </ul>


    <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center",padding:"10px 0px", borderTop:"1px solid black"}}>
      <p>अस्थायी प्रवेश हेतु संस्तुत/ असंस्तुत

</p>
 <p>अस्थायी प्रवेश स्वीकृत / अस्वीकृत
</p>
    </div>

    <ul style={{
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: '20px',
      padding: '0px !important',
      margin: '0px'
    }}>
      <li>
        <ul style={{ padding: '0px !important' }}>

          
          <li>______________</li>
          <li style={{ marginTop: '10px' }}>हस्ताक्षर: समोजक / प्रवेश सांगति
</li>
<li style={{fontWeight:"600"}}>दिनांक :</li>
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
      
        
        </ul>
      </li>
      <li>
        <ul style={{ padding: '0px !important' }}>
          <li>_____________</li>
          <li style={{ marginTop: '10px' }}>प्राचार्य के हस्ताक्षर</li>
          <li style={{fontWeight:"600"}}>दिनांक :</li>
        </ul>
      </li>
    </ul>
  </div>
);

export default Signatures;